import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as AlertIcon } from '../../../../../assets/icons/alert-color-icon-ne.svg';
import CustomModalNE from '../../../../../shared/components/ModalNE/CustomModalNE';
import StyledButtonNE from '../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import { IRewardsFileValidation } from '../../../../../shared/interfaces/rewards';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

import './FileErrorModal.scss';

interface PartialSuccessModalProps {
  validatedInfo?: IRewardsFileValidation;
  isOpen: boolean;
  primaryButtonAction: GenericVoidFunction;
  secondaryButtonAction: GenericVoidFunction;
  handleClose: GenericVoidFunction;
}

const FileErrorModal = ({
  validatedInfo,
  isOpen,
  primaryButtonAction,
  secondaryButtonAction,
  handleClose
}: PartialSuccessModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomModalNE open={isOpen} handleClose={handleClose} closeButton={false}>
      <div className="file-error-modal">
        <div className="file-error-modal-header">
          <AlertIcon className="file-error-modal-icon" />
          <div className="file-error-modal-title-container">
            <div className="file-error-modal-title">{t(TRANSLATION_POINTS_BY_FILE.fileErrorModal.title)}</div>
            <div className="file-error-modal-description">
              {t(TRANSLATION_POINTS_BY_FILE.fileErrorModal.description)}
            </div>
          </div>
        </div>

        <div className="file-error-modal-content">
          <div className="file-error-modal-box">
            <div className="file-error-modal-box-text-container">
              <Trans
                i18nKey={TRANSLATION_POINTS_BY_FILE.fileErrorModal.correctAmount}
                count={validatedInfo?.validsCount}
                components={{ 1: <b className="ne-font-numeric-md"></b>, users: validatedInfo?.validsCount }}
              />
            </div>
          </div>
          <div className="file-error-modal-box error">
            <div className="file-error-modal-box-text-container">
              <Trans
                i18nKey={TRANSLATION_POINTS_BY_FILE.fileErrorModal.errorAmount}
                count={validatedInfo?.errorsCount}
                components={{ 1: <b className="ne-font-numeric-md"></b>, users: validatedInfo?.errorsCount }}
              />
            </div>
          </div>
        </div>
        <div className="file-error-modal-buttons">
          <StyledButtonNE
            buttonType="primary"
            classes="file-error-modal-button"
            buttonSize="md"
            action={primaryButtonAction}
          >
            {t(TRANSLATION_POINTS_BY_FILE.fileErrorModal.continue)}
          </StyledButtonNE>
          <StyledButtonNE
            buttonType="tertiary"
            classes="file-error-modal-button"
            buttonSize="md"
            action={secondaryButtonAction}
          >
            {t(TRANSLATION_POINTS_BY_FILE.fileErrorModal.close)}
          </StyledButtonNE>
        </div>
      </div>
    </CustomModalNE>
  );
};

export default FileErrorModal;
